import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'formatAddress',
    standalone: false
})
export class FormatAddressPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(...args: (string | null | undefined)[]): string {
    const addressParts = args.filter(part => part && part.trim());
    return addressParts.join(', ') || this.translate.instant('NO_DATA.ADDRESS_NOT_AVAILABLE');
  }
}
